import { BaseFilter } from './base-filter';
import Project from './project';


export class KeywordFilter extends BaseFilter {
  constructor(option: any) {
    super(option)
  }

  public filter(project: Project) {
    return project.searchText(this.value.toLowerCase())
  }
}
